import React from 'react';
import './Pagination.css';

function Pagination({
    page,
    totalPages,
    totalElements,
    size,
    onPageChange,
    onSizeChange,
    sizeOptions = [10, 20, 50, 100]
}) {
    const handlePrevious = () => {
        if (page > 0) {
            onPageChange(page - 1);
        }
    };

    const handleNext = () => {
        if (page < totalPages - 1) {
            onPageChange(page + 1);
        }
    };

    const handleFirst = () => {
        onPageChange(0);
    };

    const handleLast = () => {
        onPageChange(totalPages - 1);
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        let startPage = Math.max(0, page - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(0, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return pages;
    };

    if (totalPages === 0) {
        return null;
    }

    const startItem = page * size + 1;
    const endItem = Math.min((page + 1) * size, totalElements);

    return (
        <div className="pagination-container">
            <div className="pagination-info">
                <span>총 {totalElements.toLocaleString()}개 중 {startItem}-{endItem}</span>
                {onSizeChange && (
                    <select
                        value={size}
                        onChange={(e) => onSizeChange(Number(e.target.value))}
                        className="pagination-size-select"
                    >
                        {sizeOptions.map(option => (
                            <option key={option} value={option}>{option}개씩</option>
                        ))}
                    </select>
                )}
            </div>
            <div className="pagination-buttons">
                <button
                    className="pagination-btn"
                    onClick={handleFirst}
                    disabled={page === 0}
                    title="처음"
                >
                    <span className="material-symbols-outlined">first_page</span>
                </button>
                <button
                    className="pagination-btn"
                    onClick={handlePrevious}
                    disabled={page === 0}
                    title="이전"
                >
                    <span className="material-symbols-outlined">chevron_left</span>
                </button>

                {getPageNumbers().map(pageNum => (
                    <button
                        key={pageNum}
                        className={`pagination-btn pagination-num ${pageNum === page ? 'active' : ''}`}
                        onClick={() => onPageChange(pageNum)}
                    >
                        {pageNum + 1}
                    </button>
                ))}

                <button
                    className="pagination-btn"
                    onClick={handleNext}
                    disabled={page >= totalPages - 1}
                    title="다음"
                >
                    <span className="material-symbols-outlined">chevron_right</span>
                </button>
                <button
                    className="pagination-btn"
                    onClick={handleLast}
                    disabled={page >= totalPages - 1}
                    title="마지막"
                >
                    <span className="material-symbols-outlined">last_page</span>
                </button>
            </div>
        </div>
    );
}

export default Pagination;
